var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-item"},[_c('img',{attrs:{"src":"resources/images/under-review.png","alt":"Under Review"}}),_c('p',{staticClass:"pt-5"},[_vm._v("Your request is under review!")])])
}]

export { render, staticRenderFns }